<mat-toolbar class="custom-navbar">
  <div class="container">
    <button mat-icon-button class="humburger" *ngIf="isLoggedIn" (click)="toggle()">
      <img *ngIf="!isCollapsed" src="/assets/icons/left Arrow.svg" alt="left-arrow icon" />
      <img *ngIf="isCollapsed" src="/assets/icons/Right Arrow.svg" alt="right-arrow icon" />
    </button>

    <div class="wrapper-header">
      <a routerLink="/" class="navbar-brand">
        <img src="/assets/icons/logo.svg" class="logo" alt="netsynico logo" />
      </a>

      <div class="username-wrapper" *ngIf="!isLoggedIn">
        <button mat-icon-button disableRipple="true" [matMenuTriggerFor]="signin_menu">
          <span class="link">Sign in<mat-icon class="link" style="margin-left: 0.2rem">login</mat-icon></span>
        </button>
        <mat-menu #signin_menu="matMenu">
          <div>
            <a class="link" (click)="onLogin('auth0')" routerLink="">Customer</a>
          </div>
          <div>
            <a class="link" (click)="onLogin('azure')" routerLink="">Employee</a>
          </div>
        </mat-menu>
      </div>
      <div class="username-wrapper" *ngIf="isLoggedIn">
        <button class="username" mat-icon-button disableRipple [matMenuTriggerFor]="menu">
          <img src="/assets/icons/profile-icon.svg" alt="profile-icon" />
          <span class="given-name">{{ getClaims()?.given_name }}</span>
          <i class="material-icons"> expand_more </i>
        </button>
        <!-- <small [class.blur-text]="blurHelper.enableBlur">{{ selectedAccount?.Name }}</small> -->
        <mat-menu #menu="matMenu">
          <div class="user-info">
            <ng-container *ngIf="getClaims()?.name || isLoading">
              <small> <b>Username:</b></small>
              <span class="role-name" [class.blur-text]="blurHelper.enableBlur">{{ getClaims()?.name | titlecase }}
                <img class="pl-2" id="auth0-azure-logo" [src]="getImage()" alt="logo" />
              </span>
            </ng-container>
            <ng-container *ngIf="getRoles() || isLoading">
              <small> <b>Current User Roles :</b> </small>
              <span class="role-name" [class.blur-text]="blurHelper.enableBlur">{{ getRoles() }}</span>
            </ng-container>

            <!-- <div *ngIf="isAdmin || isPresalesEngineer" class="item">
              <small><b>Assume a Customer</b></small>
              <div
                style="
                  display: flex;
                  gap: 0.5rem;
                  align-items: center;
                  margin: 0.25rem 0 0.5rem;
                "
              >
                <input placeholder="Enter CID…" #assumeCid style="flex: 1" />
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="assume(assumeCid.value)"
                >
                  Assume
                </button>
              </div>
            </div>

            <div *ngIf="imp.isImpersonating" class="item">
              <button mat-stroked-button color="warn" (click)="imp.release()">
                Release
              </button>
            </div> -->
            <!-- <mat-spinner
              *ngIf="isLoading"
              class="spinner"
              diameter="15"
            ></mat-spinner>

            <mat-spinner
              *ngIf="isLoading"
              class="spinner"
              diameter="15"
            ></mat-spinner> -->
            <!-- <ng-container
              *ngIf="
                (selectedAccount?.Name || isLoading) &&
                (isAdmin ||
                  isCustomerAdmin ||
                  isPresalesEngineer ||
                  isAccountManager)
              "
            >
              <small> Active AWS Account:</small>
              <span class="role-name" [class.blur-text]="blurHelper.enableBlur">
                {{
                  selectedAccount?.Name === "null"
                    ? "No Account Found"
                    : selectedAccount?.Name
                }}
              </span>
            </ng-container> -->

            <!-- <ng-container
              *ngIf="(selectedAccount?.Name || isLoading) && isNetsyncioUser"
            >
              <small> Active AWS Account:</small>
              <span class="role-name" [class.blur-text]="blurHelper.enableBlur">
                {{
                  selectedAccount?.Name === "null"
                    ? "No Account Found"
                    : selectedAccount?.Name
                }}
              </span>
            </ng-container> -->
            <!-- <mat-spinner
              *ngIf="isLoading"
              class="spinner"
              diameter="15"
            ></mat-spinner> -->
          </div>
          <!-- Hide Section of My Accounts from Header -->
          <!-- <div class="accounts-list">
            <ul class="accounts-names">
              <li>AWS Accounts :</li>
              <mat-spinner
                *ngIf="isLoading"
                class="spinner spinner-margin"
                diameter="20"
              ></mat-spinner>
              <ng-container
                *ngIf="
                  (isLoading || accounts?.length) &&
                  (isAdmin ||
                    isCustomerAdmin ||
                    isPresalesEngineer ||
                    isAccountManager)
                "
              >
                <li
                  *ngFor="let account of accounts | slice : 0 : 5"
                  [class.blur-text]="blurHelper.enableBlur"
                  [class.selected]="account.Id === selectedAccount?.Id"
                  (click)="accountChange($event, account)"
                >
                  {{ account?.Name }}
                </li>
              </ng-container>
              <ng-container
                *ngIf="(isLoading || accounts?.length) && isNetsyncioUser"
              >
                <li
                  *ngFor="let account of accounts | slice : 0 : 6"
                  [class.blur-text]="blurHelper.enableBlur"
                  [class.selected]="account.Id === selectedAccount?.Id"
                  (click)="accountChange($event, account)"
                >
                  {{ account?.Name }}
                </li>
              </ng-container>
            </ul>
            <p *ngIf="!isLoading && accounts?.length === 0">
              <a id="new-account" routerLink="/deploy"
                >Create New AWS Account</a
              >
            </p>
            <a
              class="see-all"
              *ngIf="
                (isLoading || accounts?.length) &&
                (isAdmin ||
                  isCustomerAdmin ||
                  isPresalesEngineer ||
                  isAccountManager)
              "
              routerLink="/operate/account-list"
              >See All
              <span class="material-icons see-all"> arrow_right_alt </span>
            </a>
          </div> -->

          <!-- <div *ngIf="!isLoading && accounts.length === 0">
            <p>
              You have no NetsyncIO managed accounts.
              <a id="new-account" routerLink="/deploy">Create New AWS Account</a>
            </p>
          </div> -->

          <div *ngIf="isAdmin || isPresalesEngineer" class="assume-block" (click)="$event.stopPropagation()">
            <small><b>Assume a Customer</b></small>


            <ng-select class="assume-field assume-customer" [items]="accountOptions" bindValue="customer_id"
              [searchFn]="searchFn" [clearable]="true" [searchable]="true" [virtualScroll]="true"
              placeholder="Choose customer" [formControl]="assumeCidCtrl" (keydown)="$event.stopPropagation()">
              <ng-template ng-option-tmp let-item="item">
                <div class="assume-item">
                  <div class="assume-item__name">{{ item.name || item.Name }}</div>
                  <div class="assume-item__cid">{{ item.customer_id }}</div>
                </div>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <div class="assume-item assume-item--selected">
                  <div class="assume-item__name">{{ item.name || item.Name }}</div>
                  <div class="assume-item__cid">{{ item.customer_id }}</div>
                </div>
              </ng-template>
            </ng-select>


            <div class="assume-actions">
              <button mat-flat-button class="save-btn" (click)="assumeSelected()" [disabled]="!assumeCidCtrl.value">
                Assume
              </button>

              <button mat-stroked-button (click)="imp.release()" [disabled]="!imp.isImpersonating">
                Release
              </button>
            </div>
          </div>

          <div>
            <p style="color: var(--dark-text)">Customer ID: {{ customerId }}</p>
          </div>

          <div class="profile">
            <a routerLink="/profile"> MY Profile </a>
          </div>

          <div class="item account-managers" *ngIf="!isLoading && accounts?.length > 0"
            (click)="openAccountManagersModal()">
            <p>Account Manager Information</p>
          </div>
          <div *ngIf="isAdmin" class="item">
            <mat-slide-toggle (click)="$event.stopPropagation()" (change)="demoModeHandler($event)"
              [formControl]="demoModeControl" disableRipple>Demo Mode</mat-slide-toggle>
          </div>
          <div class="item">
            <mat-slide-toggle [checked]="themeService.isDarkThemeSelected" (change)="toggleDarkMode($event)"
              disableRipple>
              Dark Mode
            </mat-slide-toggle>
          </div>
          <button (click)="onLogoutClick()" id="logout" mat-menu-item>
            Logout
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</mat-toolbar>

<nio-impersonation-banner *ngIf="isLoggedIn"></nio-impersonation-banner>
<!-- <router-outlet></router-outlet> -->